/**
 * A global namespace for `CapsLock` key.
 * e.which = 20 equivalent
 */
const keyCapsLock = "CapsLock";

export default keyCapsLock;
